// removed by extract-text-webpack-plugin
module.exports = {"action-panel":"action-panel","ml15":"ml15"};


//////////////////
// WEBPACK FOOTER
// ./components/business/_BusinessBox.scss
// module id = ./components/business/_BusinessBox.scss
// module chunks = 0